import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=6884febc&scoped=true&lang=pug"
import script from "./BaseListItem.vue?vue&type=script&lang=js"
export * from "./BaseListItem.vue?vue&type=script&lang=js"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=6884febc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884febc",
  null
  
)

export default component.exports